(() => {
  // ========= DEBUG =========
window.__bundleDebug = false;
  const log  = (...a) => window.__bundleDebug && console.log('[bundle]', ...a);
  const warn = (...a) => window.__bundleDebug && console.warn('[bundle]', ...a);

  const root = document.getElementById('BundleComponents');
  if (!root) return;
  if (root.dataset.initialized === '1') return;
  root.dataset.initialized = '1';

  // Masquer le picker natif après validation (mets à true quand OK)
  const HIDE_NATIVE = false;

  // ========= helpers =========
  const safeParse = s => { try { return JSON.parse(s); } catch { return null; } };
  const gidToNum  = gid => String(gid||'').match(/\d+$/)?.[0] || gid;
  const shopRoot  = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const norm = s => String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const isGold  = s => /dor|or|gold/.test(norm(s));
  const isSteel = s => /acier|steel/.test(norm(s));
  const isMix   = s => /mix/.test(norm(s));
  const keyFor  = s => isGold(s) ? 'gold' : isSteel(s) ? 'steel' : isMix(s) ? 'mix' : null;
  const pillText = k => (k==='gold' ? 'Doré' : k==='steel' ? 'Acier' : 'Mix');

  // ========= data =========
  const presets     = safeParse(root.dataset.presets)     || {};
  const presetMap   = safeParse(root.dataset.presetMap)   || {};
  const moneyFormat = safeParse(root.dataset.moneyFormat) || root.dataset.moneyFormat || '{{amount}}';
  const bonusIdRaw  = root.dataset.bonusId || '';
  const bonusLabel  = root.dataset.bonusLabel || 'Bonus';

  const list  = root.querySelector('.bundle-list');
  const pills = [...root.querySelectorAll('.bp-pill')];

  const BONUS_GID_VARIANT = `gid://shopify/ProductVariant/${bonusIdRaw}`;
  const BONUS_GID_PRODUCT = `gid://shopify/Product/${bonusIdRaw}`;

// mark pending as early as possible (prevents flash)
root.dataset.ready = '0';  // 0 = hidden, 1 = visible
root.dataset.bundleEnabled = '0';

// --- detect "real bundle" quickly and decide ---
(function guardNoRealBundle(){
  const hasRealItems = Object.values(safeParse(root.dataset.presets) || {}).some(arr =>
    Array.isArray(arr) && arr.some(it => it && it.variantId && String(it.variantId).trim())
  );

  if (!hasRealItems) {
    // never show the widget
    root.style.display = 'none';
    root.dataset.ready = '0';
    root.dataset.bundleEnabled = '0';
    // stop the rest of the script
    root.dataset.initialized = '0';
    return;
  }

  // real bundle → allow the rest of the script to run
  root.dataset.bundleEnabled = '1';
})();

// en haut (variables globales)
let bundlePropsText = '';
let bundlePropsJSON = '[]';


  // reverse map: idNum -> 'gold'|'steel'|'mix'
  const idToKey = {};
  for (const [k, gid] of Object.entries(presetMap || {})) {
    const id = gidToNum(gid);
    if (id) idToKey[id] = k;
  }

  // ========= price =========
  function findPriceNode() {
    const scope = root.closest('.product, .product-info, [id^="product-info-"]') || document;
    const sels = [
      '[data-product-price] .money','[data-product-price]',
      '.price-list [data-money]','.price-list .money',
      '.product-info .price .money','.product-info .price',
      '.product .price .money','.product .price'
    ];
    for (const s of sels){ const n = scope.querySelector(s); if (n) return n; }
    return null;
  }
  function formatMoneyCents(c){
    const cents = Math.max(0, Math.round(Number(c||0)));
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }
  function updateDisplayedPriceCents(cents){
    const node = findPriceNode(); if (!node) { warn('price node not found'); return; }
    const html = formatMoneyCents(cents);
    if (node.hasAttribute('data-money')) node.setAttribute('data-money', String(Math.round(cents)));
    const m = node.classList.contains('money') ? node : node.querySelector('.money');
    (m || node).innerHTML = html;
    log('price →', html, `(${cents}¢)`);
  }

  // ========= /variants cache =========
  const vcache = new Map();
  function fetchVariant(variantIdLike){
    const id = gidToNum(variantIdLike);
    if (!id) return Promise.resolve(null);
    if (vcache.has(id)) return vcache.get(id);
    const p = fetch(`${shopRoot}variants/${id}.js`).then(r=>r.ok?r.json():null).catch(()=>null);
    vcache.set(id, p); return p;
  }

  // ========= trouver formulaire & container d’option =========
 function findProductForm() {
  // 1) proche du widget
  let form = root.closest('form[action*="/cart/add"]');
  if (form) return form;

  // 2) scopes produit courants (Prestige & co)
  const scopes = [
    root.closest('[data-section-type="product"]'),
    root.closest('.product, .product-main, .product__info-wrapper, .Product, [id*="product"]'),
    document
  ].filter(Boolean);

  for (const scope of scopes) {
    form =
      scope.querySelector('form[action*="/cart/add"][id*="product"]') ||
      scope.querySelector('form[action*="/cart/add"][data-type="add-to-cart"]') ||
      scope.querySelector('form[action*="/cart/add"]');
    if (form && form.querySelector('[name="id"]')) return form;
  }

  // 3) fallback global
  form = [...document.querySelectorAll('form[action*="/cart/add"]')]
    .find(f => f.querySelector('[name="id"]')) || null;

  if (!form) warn('findProductForm: aucun form /cart/add trouvé');
  return form;
}


function findPackOptionContainer(form) {
  if (!form) return null;

  // Tous les conteneurs possibles d’une option (radios/select)
  const candidates = [
    // thèmes modernes
    '.variant-picker', '.variant-picker__option', '.variant-picker__option-values',
    'variant-radios', 'variant-selects',
    // prestige / sections courantes
    '.product-form__input', '.js-product-form__option', 'fieldset',
    '.block-swatch-list', '.swatch', '.radios',
  ];

  // 1) par libellé (legend / label)
  for (const sel of candidates) {
    for (const el of form.querySelectorAll(sel)) {
      const legend = el.querySelector('legend, .form__label, label[for]');
      const txt = (legend?.textContent || '').trim().toLowerCase();
      if (/(title|type|pack|composition)/i.test(txt)) return el;
    }
  }

  // 2) par valeurs “Doré / Acier / Mix” dans les labels/options
  for (const sel of candidates) {
    for (const el of form.querySelectorAll(sel)) {
      const texts = [...el.querySelectorAll('label, option, span')]
        .map(n => (n.textContent || '').toLowerCase());
      if (texts.some(t => /dor|doré|acier|mix/.test(t))) return el;
    }
  }

  warn('findPackOptionContainer: groupe Doré/Acier/Mix introuvable');
  return null;
}


  // ========= lire la valeur sélectionnée côté natif =========
  function getNativeSelectedKey(container){
    if (!container) return null;
    const checked = container.querySelector('input[type="radio"]:checked');
    if (checked){
      const lab = container.querySelector(`label[for="${checked.id}"]`);
      return keyFor(lab?.textContent || checked.value);
    }
    const sel = container.querySelector('select');
    if (sel) return keyFor(sel.options[sel.selectedIndex]?.text || sel.value);
    return null;
  }

  // ========= cliquer la vraie valeur dans le picker natif =========
  function clickNativeValue(container, wantKey){
    const want = norm(pillText(wantKey));
    if (!container) return false;

    // radios
    const radios = [...container.querySelectorAll('input[type="radio"][name*="option"], input[type="radio"][data-option-position]')];
    for (const r of radios){
      const lab = container.querySelector(`label[for="${r.id}"]`);
      const txt = norm(lab?.textContent || lab?.innerText || r.value || '');
      if (txt && (txt === want || txt.includes(want))){
        const labDisabled = lab?.classList.contains('is-disabled');
        if (lab && !labDisabled && getComputedStyle(lab).pointerEvents !== 'none') {
          lab.click(); // la plupart des thèmes écoutent le click sur le label
        } else {
          // fallback: force l’input
          r.checked = true;
          r.dispatchEvent(new Event('input',{bubbles:true}));
          r.dispatchEvent(new Event('change',{bubbles:true}));
        }
        log('native picker set →', wantKey, `(via ${lab?'label':'input'})`);
        return true;
      }
    }

    // select
    const sel = container.querySelector('select[name^="options"], select[name*="option"]');
    if (sel){
      let opt = [...sel.options].find(o => norm(o.textContent) === want);
      if (!opt) opt = [...sel.options].find(o => norm(o.value) === want);
      if (opt){
        if (sel.value !== opt.value){
          sel.value = opt.value;
          sel.dispatchEvent(new Event('input',{bubbles:true}));
          sel.dispatchEvent(new Event('change',{bubbles:true}));
        }
        log('native select set →', wantKey);
        return true;
      }
    }

    warn('native picker: valeur introuvable pour', wantKey);
    return false;
  }

  // ========= forcer l’id de variante pack (fallback fort) =========
  let internalUpdate = false;
  async function selectPackVariantId(variantGid){
    const idNum = gidToNum(variantGid); if (!idNum) return;
    const form = findProductForm(); if (!form) return;
    const idInput = form.querySelector('[name="id"]'); if (!idInput) return;

    if (String(idInput.value) !== String(idNum)){
      internalUpdate = true;
      idInput.value = String(idNum);
      idInput.dispatchEvent(new Event('change',{bubbles:true}));
      try {
        const url = new URL(location.href); url.searchParams.set('variant', idNum); history.replaceState({},'',url.toString());
      } catch {}
      internalUpdate = false;
    }

    let v=null; try{ v=await fetch(`${shopRoot}variants/${idNum}.js`).then(r=>r.ok?r.json():null);}catch{}
    const detail = v ? {variant:v} : {variantId:idNum};
    ['variant:change','product:variant:change','theme:variant:change']
      .forEach(evt => form.dispatchEvent(new CustomEvent(evt,{bubbles:true,detail})));
  }

  // ========= UI helpers =========
  function setActivePill(k){ pills.forEach(p => p.classList.toggle('is-active', p.dataset.preset === k)); }

  function isBonusItem(it){
    return !!it && (
      it.variantId === BONUS_GID_VARIANT || it.productId === BONUS_GID_PRODUCT ||
      gidToNum(it.variantId) === bonusIdRaw || gidToNum(it.productId) === bonusIdRaw
    );
  }

let renderToken = 0;   // en haut du fichier

async function renderPreset(key) {
  const token = ++renderToken;

  const items = Array.isArray(presets[key]) ? presets[key] : [];
  const visibles = items.filter(it => !!it.variantId && !isBonusItem(it));
  const bonusQty = visibles.reduce((s,it)=> s + Number(it.quantity || 0), 0);

  // charge tout en parallèle
  const rows = await Promise.all(visibles.map(async (it) => {
    const v = await fetchVariant(it.variantId);
    return { it, v };
  }));

  // si un nouveau rendu a démarré entre-temps, on abandonne celui-ci
  if (token !== renderToken) return;

  // construit le DOM en mémoire puis remplace d'un coup
  const frag = document.createDocumentFragment();
  let sum = 0;
  for (const { it, v } of rows) {
    const name = (v && (v.name || v.title || v.public_title)) || 'Variante';
    const img  = v?.featured_image ? (typeof v.featured_image === 'string' ? v.featured_image : (v.featured_image.src || '')) : '';
    const li = document.createElement('li');
    li.className = 'bundle-item';
    li.innerHTML = `${img?`<img class="bundle-img" src="${img}&width=80" alt="">`:`<span class="bundle-img"></span>`}
      <span class="bundle-title-txt">${String(name).replace(/</g,'&lt;')}</span>
      <span class="bundle-qty">× ${Number(it.quantity||1)}</span>`;
    frag.appendChild(li);

    sum += Number(v?.price || 0) * Number(it.quantity || 1);
  }

  if (bonusQty > 0) {
    const liB = document.createElement('li');
    liB.className = 'bundle-item';
    liB.innerHTML = `<span class="bundle-img"></span><span class="bundle-title-txt">${String(bonusLabel||'Bonus').replace(/</g,'&lt;')}</span><span class="bundle-qty">× ${bonusQty}</span>`;
    frag.appendChild(liB);
  }
// NEW — préparer les propriétés de ligne pour la commande
const humanLines = rows.map(({ v, it }) => {
  const label = (v && (v.name || v.title || v.public_title)) || 'Variante';
  return `${label} × ${Number(it.quantity || 1)}`;
});

// Bonus (sac & écrin) — à inclure ou pas selon ton souhait
if (bonusQty > 0) humanLines.push(`${bonusLabel||'Bonus'} × ${bonusQty}`);

bundlePropsText = humanLines.join('\n');

// JSON compact "id:qty" (id numérique pour rester court)
bundlePropsJSON = JSON.stringify(
  visibles.map(it => ({ id: gidToNum(it.variantId), q: Number(it.quantity || 1) }))
);

window.bundlePropsText = bundlePropsText;
window.bundlePropsJSON = bundlePropsJSON;
// si le panneau debug a un refresh, déclenche-le
if (typeof window.__bundleRefresh === 'function') window.__bundleRefresh();
  // >>> AJOUT ICI : tenir les <input name="properties[...]"> à jour en continu
  {
    const form = findProductForm();
    ensurePropertyInputs(form);
    installFormdataHook(form);
  }
  list.innerHTML = '';
  list.appendChild(frag);
  updateDisplayedPriceCents(sum);
  setActivePill(key);
}


  // ========= suivre le thème → activer la bonne pill =========
  function bindThemeToPills(){
    const form = findProductForm(); if (!form) { warn('form introuvable'); return; }
    const container = findPackOptionContainer(form);
    const idInput   = form.querySelector('[name="id"]');

    const updateFromNative = () => {
      if (internalUpdate) return;
      const k = container && getNativeSelectedKey(container);
      if (k) { setActivePill(k); renderPreset(k); }
    };

    const updateFromId = () => {
      if (internalUpdate) return;
      const id = idInput && gidToNum(idInput.value);
      const k  = id && idToKey[id];
      if (k) { setActivePill(k); renderPreset(k); }
    };

    container && container.addEventListener('change', updateFromNative);
    idInput   && idInput.addEventListener('change', updateFromId);

    // observe si le thème re-render
    if (container) {
      const mo = new MutationObserver(() => {
        const k = getNativeSelectedKey(container);
        if (k) setActivePill(k);
      });
      mo.observe(container, {childList:true,subtree:true,attributes:true});
    }
  }

  function maybeHideNativePicker(){
    if (!HIDE_NATIVE) return;
    const target = findPackOptionContainer(findProductForm());
    if (target) target.style.display='none';
  }

  // ========= écoute des clics sur les pills (délégation) =========
  // ... (tout ton code inchangé au-dessus)

function setChunkedHumanProps(form, text, keyBase='Contenu du pack') {
  const MAX = 240; // marge de sécu
  const chunks = [];
  for (let i = 0; i < text.length; i += MAX) chunks.push(text.slice(i, i + MAX));
  chunks.forEach((chunk, idx) => {
    const key = idx === 0 ? keyBase : `${keyBase} (${idx+1})`;
    upsertPropInput(form, key, chunk);
  });
}

  // ========= init =========
  const initial = (root.querySelector('.bp-pill.is-active') || pills[0])?.dataset.preset || 'gold';
  log('init →', { initial, presets, presetMap });
  bindThemeToPills();
(() => {
  const form = findProductForm();
  if (form) {
    form.addEventListener('submit', () => {
      ensurePropertyInputs(form);   // pas de setChunkedHumanProps ni d’upsert direct
    }, true);
  }
})();
  // ★ AJOUT : synchro immédiate du natif avec la pill active au chargement
  (() => {
    const form = findProductForm();
    const container = findPackOptionContainer(form);
    if (container) clickNativeValue(container, initial);
  })();
renderPreset(initial).then(() => {
  // now widget can be shown with no blink
  root.dataset.ready = '1';
  // (optional) hide native picker now that we're live
  maybeHideNativePicker();
});

/* --- NETWORK PATCH: force properties into /cart/add(.js) --- */
(() => {
  const ORIG_FETCH = window.fetch;

  function splitChunks(text, max = 240) {
    const out = [];
    for (let i = 0; i < text.length; i += max) out.push(text.slice(i, i + max));
    return out.length ? out : [''];
  }
  function buildProps() {
    const txt = window.bundlePropsText || '';
    const json = window.bundlePropsJSON || '[]';
    const chunks = splitChunks(txt, 240);
    const props = {};
    chunks.forEach((c, i) => props[`Contenu du pack${i ? ` (${i+1})` : ''}`] = c);
    props['_Bundle JSON'] = json;
    return props;
  }
  function injectFormData(fd) {
    const p = buildProps();
    Object.entries(p).forEach(([k, v]) => fd.set(`properties[${k}]`, v));
  }
  function injectSearch(us) {
    const p = buildProps();
    Object.entries(p).forEach(([k, v]) => us.set(`properties[${k}]`, v));
  }
  function injectJSON(bodyStr) {
    let data = {};
    try { data = JSON.parse(bodyStr || '{}'); } catch {}
    data.properties = Object.assign({}, data.properties || {}, buildProps());
    return JSON.stringify(data);
  }

  window.fetch = function(input, init = {}) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = String(init?.method || 'GET').toUpperCase();
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    if (isAdd && method === 'POST') {
      const headers = new Headers(init.headers || {});
      const ct = (headers.get('Content-Type') || '').toLowerCase();

      if (init.body instanceof FormData) {
        injectFormData(init.body);
      } else if (init.body instanceof URLSearchParams) {
        injectSearch(init.body);
        if (!ct) headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        init.headers = headers;
      } else if (typeof init.body === 'string') {
        if (ct.includes('application/json') || init.body.trim().startsWith('{')) {
          init.body = injectJSON(init.body);
          if (!ct) headers.set('Content-Type', 'application/json');
        } else {
          const us = new URLSearchParams(init.body);
          injectSearch(us);
          init.body = us.toString();
          if (!ct) headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        }
        init.headers = headers;
      } else if (init.body && typeof init.body === 'object') {
        init.body = injectJSON(JSON.stringify(init.body));
        headers.set('Content-Type', 'application/json');
        init.headers = headers;
      }
    }
    return ORIG_FETCH.apply(this, arguments);
  };
})();



  // debug global
  window.__bundle = Object.assign(window.__bundle||{}, { renderPreset, findProductForm, findPackOptionContainer });
})();


/* --- PATCH : sync .is-active + clic natif, résistant aux re-renders --- */
(() => {
  const TAG = '[bundle-patch]';
  let lastKey = null;            // mémorise le dernier choix (pour re-render)
  let installedFor = null;       // id de root en cours (pour éviter double install)

  const norm = s => String(s||'').toLowerCase().trim();
  const pills = root => Array.from(root.querySelectorAll('.bundle-presets-switch .bp-pill'));
  const setActiveBtn = (root, btn) => {
    pills(root).forEach(p => {
      const on = (p === btn);
      if (on !== p.classList.contains('is-active')) {
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
  };
  const setActiveByKey = (root, key) => {
    if (!root || !key) return;
    const btn = pills(root).find(b => (b.dataset.preset||'') === key);
    if (btn) setActiveBtn(root, btn);
  };

  // Cherche un radio "option-value-N-*" (DOM + shadow)
  function findRadioByIndex(idx){
    const prefix = `option-value-${idx+1}-`;
    // 1) DOM direct
    let r = document.querySelector(`input[type="radio"][id^="${prefix}"]`);
    if (r) return { el:r, via:'document' };
    // 2) shadow roots des <variant-picker>
    for (const vp of document.querySelectorAll('variant-picker')){
      const sr = vp.shadowRoot;
      if (sr){
        const r2 = sr.querySelector(`input[type="radio"][id^="${prefix}"]`);
        if (r2) return { el:r2, via:'variant-picker.shadowRoot' };
      }
    }
    // 3) deep traversal
    const stack=[document]; const seen=new Set();
    while(stack.length){
      const n=stack.pop(); if(!n||seen.has(n)) continue; seen.add(n);
      if (n.querySelector){
        try{ const m=n.querySelector(`input[type="radio"][id^="${prefix}"]`); if (m) return { el:m, via:'deep' }; }catch{}
      }
      if (n.childNodes) n.childNodes.forEach(c=>stack.push(c));
      if (n.shadowRoot) stack.push(n.shadowRoot);
    }
    return { el:null, via:'none' };
  }

  function forceNativeByBtn(root, btn){
    const idx = pills(root).indexOf(btn);
    if (idx < 0) return;
    const res = findRadioByIndex(idx);
    console.log(TAG, 'radio search', { index: idx, found: !!res.el, via: res.via, id: res.el?.id||null });
    if (!res.el) return;

    const radio = res.el;
    const labSel = `label[for="${CSS.escape(radio.id)}"]`;
    let lab = document.querySelector(labSel);
    if (!lab){
      const vp = radio.closest?.('variant-picker');
      if (vp?.shadowRoot) lab = vp.shadowRoot.querySelector(labSel);
    }
    const clickable = !!(lab && getComputedStyle(lab).pointerEvents !== 'none' && !lab.classList.contains('is-disabled'));
    try{
      if (clickable){
        lab.click();
      } else {
        radio.checked = true;
        radio.setAttribute('selected','selected');      // (trace demandée)
        radio.dispatchEvent(new Event('input',  { bubbles:true }));
        radio.dispatchEvent(new Event('change', { bubbles:true }));
        radio.closest?.('variant-picker')?.dispatchEvent(new Event('change', { bubbles:true }));
      }
    }catch(e){ console.warn(TAG,'forceNative error', e); }
  }

  function installForRoot(root){
    if (!root || installedFor === root) return;
    installedFor = root;
    console.log(TAG, 'install on', root);

    // Délégation : un seul listener, robuste au re-render
    root.addEventListener('click', (ev)=>{
      const btn = ev.target.closest('.bp-pill');
      if (!btn || !root.contains(btn)) return;

      // LOG avant/après (état des classes)
      const before = btn.className;
      setActiveBtn(root, btn);
      const after = btn.className;
      console.log(TAG, 'CLICK pill', { text:(btn.textContent||'').trim(), key:btn.dataset.preset, before, after });

      // Pousser le natif + appeler ta logique
      forceNativeByBtn(root, btn);

      const key = btn.dataset.preset;
      lastKey = key;                         // mémoriser pour les prochains re-renders
      if (key && window.__bundle?.renderPreset){
        ev.preventDefault();
        window.__bundle.renderPreset(key);
      }

      // Re-asserter si un autre script réécrit les classes
      requestAnimationFrame(()=> setActiveBtn(root, btn));
      setTimeout(()=> setActiveBtn(root, btn), 0);
    }, true);

    // Synchro initiale : si on a déjà choisi quelque chose, réappliquer
    if (lastKey) setActiveByKey(root, lastKey);
  }

  // 1) première install (si root déjà là)
  const current = document.getElementById('BundleComponents');
  if (current) installForRoot(current);

  // 2) Observer global : si la section est remplacée, on réinstalle et on réapplique lastKey
  const mo = new MutationObserver(() => {
    const r = document.getElementById('BundleComponents');
    if (r && r !== installedFor) {
      installForRoot(r);
      if (lastKey) {
        setActiveByKey(r, lastKey);
        // double tick pour les thèmes qui posent leurs classes après un rAF
        requestAnimationFrame(()=> setActiveByKey(r, lastKey));
      }
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });
})();

/* --- PATCH : cacher le picker natif uniquement pour les VRAIS bundles --- */
(() => {
  const root = document.getElementById('BundleComponents');
  // on exige la présence ET l'activation explicite
  if (!root || root.dataset.bundleEnabled !== '1') return;

  const SELECTORS = [
    '.product-info__block-item[data-block-id="variant_picker"]',
    '.variant-picker',
    'variant-picker',
    'variant-radios',
    'variant-selects',
  ];

  function getScope() {
    return (
      root.closest('[data-section-type="product"]') ||
      root.closest('.product, .product-main, .product__info-wrapper, .Product') ||
      document
    );
  }

  function hideNativePicker() {
    const scope = getScope();
    for (const sel of SELECTORS) {
      scope.querySelectorAll(sel).forEach(el => {
        if (el.dataset.bundleHidden === '1') return;
        el.dataset.bundleHidden = '1';
        el.style.display = 'none';
      });
    }
  }

  hideNativePicker();

  const mo = new MutationObserver(() => {
    // si entre-temps le bundle a été désactivé, on arrête
    if (root.dataset.bundleEnabled !== '1') { mo.disconnect(); return; }
    hideNativePicker();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


// helper NEW : crée/maj un <input name="properties[...]"> dans le form
function upsertPropInput(form, key, value) {
  const name = `properties[${key}]`;
  let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }
  input.value = value;
}

// ensure avant submit NEW
function injectBundlePropsIntoForm() {
  const form = findProductForm(); if (!form) return;
  upsertPropInput(form, 'Contenu du pack', bundlePropsText);

  setChunkedHumanProps(form, bundlePropsText);  // au lieu d’un seul "Contenu du pack"
upsertPropInput(form, '_Bundle JSON', bundlePropsJSON);
}
// DRY-RUN: maintenir ALT (⌥) en cliquant sur "Ajouter au panier"
document.addEventListener('click', (ev) => {
  const btn = ev.target.closest('button[type="submit"], [name="add"]');
  if (!btn) return;

  if (ev.altKey) { // ⌥ = dry-run
    ev.preventDefault();
    const form = btn.form || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    ensurePropertyInputs(form);


    const fd = new FormData(form);
    const props = [...fd.entries()].filter(([k]) => k.startsWith('properties['));

    console.group('[bundle] DRY-RUN — propriétés qui seraient envoyées');
    props.forEach(([k, v]) => console.log(k, '→', v));
    console.log('_Bundle JSON →', [...fd.entries()].find(([k]) => k === 'properties[_Bundle JSON]')?.[1]);
    console.groupEnd();

    alert('Dry-run : regarde la console → propriétés prêtes à l’envoi (rien n’a été ajouté au panier).');
  }
}, true);
if (window.__bundleDebug) {
  const root = document.getElementById('BundleComponents');
  if (root) {
    const box = document.createElement('details');
    box.open = true;
    box.style.marginTop = '8px';
    box.innerHTML = `<summary>Prévisualisation du pack</summary>
      <pre id="bpTxt" style="white-space:pre-wrap"></pre>
      <pre id="bpJson" style="white-space:pre-wrap"></pre>`;
    root.appendChild(box);

    const refresh = () => {
      const txt = window.bundlePropsText || '(vide)';
      const json = window.bundlePropsJSON || '[]';
      box.querySelector('#bpTxt').textContent = txt;
      box.querySelector('#bpJson').textContent = json;
    };

    window.__bundleRefresh = refresh; 
    // rafraîchir après chaque renderPreset
    const orig = window.__bundle?.renderPreset;
    if (orig) {
      window.__bundle.renderPreset = async (k) => { const r = await orig(k); refresh(); return r; };
    }
    refresh();
  }
}

// util: coupe un long texte en morceaux de 240 chars
function chunkText(txt, max = 240){
  const out=[]; for(let i=0;i<txt.length;i+=max) out.push(txt.slice(i,i+max)); return out.length?out:[''];
}

// (1) crée/MAJ les inputs cachés à l'intérieur du form
function ensurePropertyInputs(form){
  if(!form) return;
  // on efface les anciens inputs gérés par nous
  form.querySelectorAll('input[data-bundle-prop="1"]').forEach(n=>n.remove());

  // texte humain (chunké)
  const chunks = chunkText(bundlePropsText, 240);
  chunks.forEach((chunk, i) => {
    const inp = document.createElement('input');
    inp.type  = 'hidden';
    inp.name  = `properties[Contenu du pack${i?` (${i+1})`:''}]`;
    inp.value = chunk;
    inp.setAttribute('data-bundle-prop','1');
    form.appendChild(inp);
  });

  // JSON technique compact
  const j = document.createElement('input');
  j.type='hidden';
  j.name='properties[_Bundle JSON]';
  j.value=bundlePropsJSON;
  j.setAttribute('data-bundle-prop','1');
  form.appendChild(j);
}

// (2) hook formdata (passe *toujours* même si le thème utilise new FormData)
function installFormdataHook(form){
  if(!form || form._bundleFormdataHooked) return;
  form._bundleFormdataHooked = true;

  form.addEventListener('formdata', (ev) => {
    const fd = ev.formData;
    const set = fd.set ? (k,v)=>fd.set(k,v) : (k,v)=>{ try{fd.delete(k);}catch{} fd.append(k,v); };

    // chunks
    const chunks = chunkText(bundlePropsText, 240);
    chunks.forEach((chunk, i) => set(`properties[Contenu du pack${i?` (${i+1})`:''}]`, chunk));

    // JSON
    set('properties[_Bundle JSON]', bundlePropsJSON);

    console.log('[bundle] formdata → properties injectées');
  }, true);
}
